import MissingPodCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['status', 'isFinished'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { status, isFinished } = props.selectors.getJourneyFields(state, props.journeyId, fields);

    return {
      missingPod: isFinished && status === 'DONE_WITHOUT_MANIFEST',
    };
  })
);

export default enhance(MissingPodCell);
